import Http from '@/common/http'
export default class Auth {
  static getUserInfo (param = {}) {
    return Http.post('/index/index/getUserInfo', param)
  }
  static login (param = {}) {
    return Http.post('/index/index/login', param)
  }
  static logout (param = {}) {
    return Http.post('/index/index/logout', param)
  }
  static getOauthUrl (param = {}) {
    return Http.post('/index/index/getOauthUrl', param)
  }
  static checkUserInfo (param = {}) {
    return Http.post('/index/index/checkUserInfo', param)
  }
  static regUser (param = {}) {
    return Http.post('/index/index/regUser', param)
  }
}
